import React, { memo } from 'react';
import HBTextAreaField, {
    HBTextAreaFieldProps
} from '../HBTextAreaField/HBTextAreaField';
import useFormFieldProps, {
    FormFieldProps,
    TFormInputValidationProps,
    useFormInputValidationProps
} from './useFormFieldProps';

type Props = Omit<
    FormFieldProps<HBTextAreaFieldProps>,
    TFormInputValidationProps
>;

const HBFormTextAreaField = (props: Props) => {
    const fieldProps = useFormFieldProps(props, true);
    const validationProps = useFormInputValidationProps(props.id);

    return <HBTextAreaField {...fieldProps} {...validationProps} />;
};

export default memo(HBFormTextAreaField);
